import { createTheme } from '@material-ui/core/styles'
import { adaptV4Theme, createTheme as createThemeV5 } from '@mui/material'
import { DEFAULT_THEME_CONFIG } from '@scoir/mui-theme'

const themeConfig = {
  ...DEFAULT_THEME_CONFIG,
  typography: {
    ...DEFAULT_THEME_CONFIG.typography,
    fontFamily: 'Roboto, sans-serif',
    h1: {
      ...DEFAULT_THEME_CONFIG.typography.h1,
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 300,
    },
    h2: {
      ...DEFAULT_THEME_CONFIG.typography.h2,
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 300,
    },
    h3: {
      ...DEFAULT_THEME_CONFIG.typography.h3,
      fontFamily: 'Roboto, sans-serif',
    },
    h4: {
      ...DEFAULT_THEME_CONFIG.typography.h4,
      fontFamily: 'Roboto, sans-serif',
    },
    h5: {
      ...DEFAULT_THEME_CONFIG.typography.h5,
      fontFamily: 'Roboto, sans-serif',
    },
    h6: {
      ...DEFAULT_THEME_CONFIG.typography.h6,
      fontFamily: 'Roboto, sans-serif',
    },
    subtitle1: {
      ...DEFAULT_THEME_CONFIG.typography.subtitle1,
      fontFamily: 'Roboto, sans-serif',
    },
    subtitle2: {
      ...DEFAULT_THEME_CONFIG.typography.subtitle2,
      fontFamily: 'Roboto, sans-serif',
      fontWeight: 500,
      fontSize: '1.6rem',
    },
    body1: {
      ...DEFAULT_THEME_CONFIG.typography.body1,
      fontFamily: 'Roboto, sans-serif',
    },
    body2: {
      ...DEFAULT_THEME_CONFIG.typography.body2,
      fontFamily: 'Roboto, sans-serif',
    },
    caption: {
      ...DEFAULT_THEME_CONFIG.typography.caption,
      fontFamily: 'Roboto, sans-serif',
    },
    overline: {
      ...DEFAULT_THEME_CONFIG.typography.overline,
      fontFamily: 'Roboto, sans-serif',
    },
  },
}
const theme = createTheme(themeConfig)

export const themeV5 = createThemeV5(
  adaptV4Theme({
    ...themeConfig,
    breakpoints: theme.breakpoints,
    palette: theme.palette,
    typography: theme.typography,
    props: {
      MuiButtonBase: {
        disableRipple: true,
      },
      MuiCard: {
        elevation: 2,
      },
    },
    overrides: {
      MuiDataGrid: {
        root: {
          border: 'none',
          '.MuiDataGrid-columnHeaderCheckbox + .MuiDataGrid-columnHeader': {
            borderLeft: 'none',
          },
          '.MuiDataGrid-cellCheckbox + .MuiDataGrid-cell': {
            borderLeft: 'none',
          },
        },
        columnSeparator: {
          color: 'transparent',
          '$root &:hover': {
            color: 'inherit',
          },
        },
        columnHeaders: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          borderTop: `1px solid ${theme.palette.divider}`,
          background: '#F5F8FA',
        },
        columnHeader: {
          borderLeft: `1px solid ${theme.palette.divider}`,
          '&:focus:not(:focus-visible)': {
            outline: 'transparent',
          },
        },
        columnHeaderCheckbox: {
          borderLeft: 'none',
        },
        footerContainer: {
          borderTop: `1px solid ${theme.palette.divider}`,
          justifyContent: 'center',
        },
        cell: {
          borderBottom: `1px solid ${theme.palette.divider}`,
          '&:focus:not(:focus-visible)': {
            outline: 'transparent',
          },
          '&--textLeft': {
            borderLeft: `1px solid ${theme.palette.divider}`,
          },
        },
        cellCheckbox: {
          borderLeft: 'none',
        },
      },
      MuiTablePagination: {
        selectLabel: {
          margin: '0px',
        },
        displayedRows: {
          margin: '0px',
        },
      },
    },
  }),
)

export default theme
